const translations = {
    en: {
        welcome: {
            customize_your_stay: {
                title: "Customize your stay",
                text: "We do everything to make your trip unique: at your disposal many services for every need."
            }
        }
    },
    de: {
        welcome: {
            customize_your_stay: {
                title: "Passen Sie Ihren Aufenthalt an",
                text: "Wir tun alles, um Ihre Reise einzigartig zu machen: viele Dienstleistungen stehen zur ihren Verfügung für jeden Bedarf."
            }
        }
    },
    es: {
        welcome: {
            customize_your_stay: {
                title: "Personalize su estancia",
                text: "Hacemos de todo para que su viaje sea unico y inolvidable: tenemos muchos servicios, a su alcance, para cada necesidad"
            }
        }
    },
    fr: {
        welcome: {
            customize_your_stay: {
                title: "Personnalisez votre séjour",
                text: "On fait notre possible pour rendre unique votre voyage: découvrez nos services pour tous les besoins."
            }
        }
    },
    it: {
        welcome: {
            customize_your_stay: {
                title: "Personalizza il tuo soggiorno",
                text: "Facciamo di tutto per rendere unico il tuo viaggio: a tua disposizione tanti servizi per ogni esigenza."
            }
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/welcome/CustomizeYourStay.js